<div id="page-empleados" class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header accent"
             fxLayout="column" fxLayoutAlign="center center"
             fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

            <!-- APP TITLE -->
            <div class="logo mb-24 mb-sm-0"
                 fxLayout="row" fxLayoutAlign="start center">
                <mat-icon class="logo-icon s-32 mr-16" [@animate]="{value:'*',params:{delay:'50ms',scale:'0.2'}}">
                    people
                </mat-icon>
                <span class="logo-text h1" [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">{{'EMPLEADOS.LIST.TITLE' | translate}}</span>
            </div>
            <!-- / APP TITLE -->

            <!-- SEARCH -->
            <div class="search-wrapper  ml-sm-32">
                <div class="search" fxFlex fxLayout="row" fxLayoutAlign="end center">
                    <mat-icon>search</mat-icon>
                    <input #filter placeholder="Buscar un empleado">
                </div>
            </div>
            <!-- / SEARCH -->

            <!-- ACTIONS -->
            <div class="toolbar-action-button-row" fxLayout="row" fxLayoutAlign="end center" >
                <button [routerLink]="'/empleados/add'" mat-raised-button color="primary" aria-label="Nuevo empleado" title="Nuevo empleado">Nuevo empleado</button>
            </div>
            <!-- / ACTIONS -->

        </div>
        <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">

            <mat-table class="empleados-table"
                       #table [dataSource]="dataSource"
                       matSort
                       [@animateStagger]="{value:'50'}"
                       fusePerfectScrollbar>

                <!-- ID Column -->
                <ng-container matColumnDef="id">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Id</mat-header-cell>
                    <mat-cell *matCellDef="let data">
                        <p class="text-truncate">{{data.id}}</p>
                    </mat-cell>
                </ng-container>

                <!-- nameColumn -->
                <ng-container matColumnDef="name">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-sm>Nombre</mat-header-cell>
                    <mat-cell *matCellDef="let data" fxHide fxShow.gt-sm>
                        <p class="text-truncate">{{data.name}}</p>
                    </mat-cell>
                </ng-container>

                <!-- Job Column -->
                <ng-container matColumnDef="job">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Posición</mat-header-cell>
                    <mat-cell *matCellDef="let data">
                        <p class="text-truncate">{{data.job}}</p>
                    </mat-cell>
                </ng-container>

                <!-- Status Column -->
                <ng-container matColumnDef="active">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Status</mat-header-cell>
                    <mat-cell *matCellDef="let data">
                        <mat-icon *ngIf="data.active" class="active-icon green-600 s-16">check</mat-icon>
                        <mat-icon *ngIf="!data.active" class="active-icon red-500 s-16">close</mat-icon>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="acciones">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Acciones</mat-header-cell>
                    <mat-cell *matCellDef="let data">
                        <div class="toolbar-action-button-row">
                            <button mat-mini-fab color="accent" title="Editar" aria-label="Editar" [routerLink]="'/empleados/edit/'+data.id" >
                                <mat-icon class="active-icon " >edit</mat-icon>
                            </button>
                            <button mat-mini-fab color="accent" title="Activar" aria-label="Activar" *ngIf="!data.active" (click)="activate(true, data.id)">
                                <mat-icon class="active-icon " >done</mat-icon>
                            </button>
                            <button mat-mini-fab color="warn" title="Inactivar" aria-label="Inactivar" *ngIf="data.active" (click)="activate(false, data.id)">
                                <mat-icon class="active-icon " >highlight_off</mat-icon>
                            </button>
                            <button mat-mini-fab color="warn" title="Borrar" aria-label="Borrar" (click)="deleteItem(data.id)">
                                <mat-icon class="active-icon " >delete</mat-icon>
                            </button>
                        </div>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

                <mat-row *matRowDef="let data; columns: displayedColumns;"
                         class="order"
                         matRipple
                        >
                </mat-row>
            </mat-table>

            <mat-paginator #paginator
                           [length]="dataSource.filteredData.length"
                           [pageIndex]="0"
                           [pageSize]="10"
                           [pageSizeOptions]="[10, 25, 100]">
            </mat-paginator>

        </div>
        <!-- / CONTENT CARD -->
    </div>
    <!-- / CENTER -->
</div>
